// Personal Information
export const PERSONAL_INFO = {
  name: 'AMIT HALFON',
  title: 'Software Engineer',
  github: 'amitha511',
  linkedin: 'amithalfon',
};

export const HOME_HERO = {
  highlights: [
    {
      id: 'focus',
      label: 'Focus',
      text: 'Backend & Distributed Systems',
    },
    {
      id: 'stack',
      label: 'Stack',
      tags: ['Java', 'Node.js', 'Kubernetes', 'Docker', 'Kafka', 'AWS', 'SQL', 'NoSQL','Claude','Cursor'],
    },
    {
      id: 'background',
      label: 'Background',
      lines: ['B.Sc. Computer Science', 'Software developer experience'],
    },
  ],
};

// Social Media Links
export const SOCIAL_LINKS = {
  github: 'https://github.com/amitha511',
  linkedin: 'https://www.linkedin.com/in/amithalfon/',
};

// Navigation Items
export const NAV_ITEMS = [
  { path: '/', label: 'Home', icon: 'AiOutlineHome' },
  { path: '/about', label: 'About', icon: 'AiOutlineUser' },
  { path: '/projects', label: 'Projects', icon: 'AiOutlineFundProjectionScreen' },
  { path: '/articles', label: 'Articles', icon: 'ImBlog' },
];

// Section Titles
export const SECTION_TITLES = {
  projects: {
    client: 'Projects for clients',
    personal: 'Personal projects',
  },
  about: {
    intro:  'About Me',
    skillset: 'Professional Skillset',
    tools: 'Tools I use',
  },
  articles: {
    main: 'My Blog Articles',
    subtitle: 'Here are my latest technical writings and tutorials.',
    featured: 'My Articles',

  },
};

// Theme Colors (for potential future use)
export const THEME_COLORS = {
  primary: '#c770f0',
  secondary: '#be50f4',
  background: 'rgba(17, 16, 16, 0.582)',
};